import { useEffect, useState } from "react"

interface ScrollPosition {
  x: number
  y: number
}

export function useScrollPosition(): ScrollPosition {
  const [scrollPosition, setScrollPosition] = useState<ScrollPosition>({ x: 0, y: 0 })

  useEffect(() => {
    const handleScroll = (): void => {
      setScrollPosition({ x: window.scrollX, y: window.scrollY })
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Initial scroll position on mount

    return (): void => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return scrollPosition
}

export default useScrollPosition
